<template>
  <div class="childtrackingsystem-results">
    <div
      v-if="isLoading"
      class="row bg-white"
    >
      <div class="col-12 text-center">
        <img
          src="../../assets/img/loading.gif"
          alt="Loading"
          style="width: 80px; height: 80px;"
        >
      </div>
    </div>
    <div
      v-if="!isAnalyse && !isChildForm"
      class="row bg-white pt-3 pb-3"
    >
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedMentor"
        >Invuller</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="mentor"
          placeholder="Zoek..."
          name="mentor"
          list="mentors-list"
          v-model="searchedMentor"
          @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="mentors-list">
          <option value="Alle" selected></option>
          <option
            v-for="mentor in mentors"
            :value="mentor.name"
            :key="mentor.id"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedList"
        >Observatielijst</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="selectedList"
          placeholder="Zoek..."
          name="selectedList"
          list="lists-list"
          v-model="searchedList"
          @focus="searchedList = ''; document.getElementById('lists-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="lists-list">
          <option value="Alle" selected></option>
          <option
            v-for="list in lists"
            :key="list.id"
            :value="list.title"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="filterChildren"
        >Filter kinderen</label>
        <select
          class="form-select form-select-sm"
          id="filterChildren"
          name="filterChildren"
          v-model="filterChildren"
          @change="getResults(showActive)"
        >
          <option value="all">Alle</option>
          <option value="present">Aanwezig</option>
          <option value="vve">VVE</option>
        </select>
      </div>
    </div>
    <div class="row bg-white" v-if="isError">
      <div class="col-12 alert alert-danger text-center">{{ message }}</div>
    </div>
    <div class="row bg-white" v-if="isSuccess">
      <div class="col-12 alert alert-info text-center">{{ message }}</div>
    </div>
    <div
      v-if="!isAnalyse && !isChildForm"
      class="row bg-white"
    >
      <div
        v-if="isAllResults"
        class="col-md-12"
      >
        <table class="table">
          <thead>
            <tr>
              <th>Observatielijst
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#infoModal"
                >
                                    <icon name="info"></icon>
                                </span>
              </th>
              <th class="text-end pe-1">
                <button
                  class="btn btn-sm btn-outline-danger"
                  @click="getResults(false)"
                  v-if="showActive"
                >Ga naar archief
                </button>
                <button
                  class="btn btn-sm btn-outline-success"
                  @click="getResults(true)"
                  v-if="!showActive"
                >Verlaat archief
                </button>

              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(result,key) in filteredRows"
              :key="key"
            >
              <td :style="'color:' + result.alert">
                <b>{{ result.listTitle }}</b> van kind <b>{{ result.childName }}</b>
                ({{ result.childAge }}) opgeslagen op {{ result.date }}
              </td>
              <td
                class="text-end pe-1"
                style="width:180px;"
              >
                                <span
                                  style="margin-top: 5px; margin-right: 15px;color:#666;"
                                  title="Bekijk"
                                  @click="openAnalyse(result.id)"
                                >
                                    <icon name="look-into"></icon>
                                </span>
                <span
                  style="margin-top: 5px; margin-right: 15px;"
                  title="Herinnering"
                  data-bs-toggle="modal"
                  :data-bs-target="'#' + 'triggerModal-' + result.id"
                >
                  <icon name="reminder"></icon>
                </span>
                <div
                  class="modal modal-lg fade"
                  :id="'triggerModal-' + result.id"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body">
                        <div class="row row-cols-auto d-flex align-items-center py-2 border-top border-bottom">
                          <label class="col col-form-label fw-bold">Periode</label>
                          <div class="col">
                            <select
                              class="form-select form-select-sm"
                              id="triggerPeriod"
                              name="triggerPeriod"
                              @change="changeTrigger($event)"
                            >
                              <option
                                value="0"
                                selected
                              >Kies een periode
                              </option>
                              <option value="1">Over 1 week</option>
                              <option value="2">Over 2 weken</option>
                              <option value="3">Over 3 weken</option>
                              <option value="4">Over 4 weken</option>
                              <option value="8">Over 2 maanden</option>
                              <option value="12">Over 3 maanden</option>
                              <option value="16">Over 4 maanden</option>
                              <option value="20">Over 5 maanden</option>
                              <option value="24">Over 6 maanden</option>
                            </select>
                          </div>
                          <div class="col">OF</div>
                          <label class="col col-form-label fw-bold">Datum</label>
                          <div class="col">
                            <input
                              id="triggerDate"
                              type="date"
                              name="triggerDate"
                              size="12"
                              @input="changeTrigger($event);"
                            >
                          </div>
                        </div>
                        <div class="row row-cols-auto d-flex align-items-center py-2 border-top">
                          <label class="col col-form-label fw-bold">Omschrijving</label>
                          <div class="col-10">
                            <textarea
                              class="form-control"
                              id="triggerDescription"
                              name="triggerDescription"
                              @input="changeTrigger($event)"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button
                          class="btn btn-secondary"
                          name="action"
                          value="saveTrigger"
                          data-bs-dismiss="modal"
                          @click="saveTrigger(result.id)"
                        >
                          Opslaan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  style="margin-top: 5px; margin-right: 15px;color:#666;"
                  title="Maak formulier aan"
                  @click="openChildForm(result.id, result.idChildForm)"
                >
                  <icon name="file-contract"></icon>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="isAnalyse">
      <childtrackingsystem-editchildobservationlist :idResult="selectedResult"></childtrackingsystem-editchildobservationlist>
    </div>
    <div v-if="isChildForm">
      <childtrackingsystem-observationform
        :idResult="selectedResult"
        :idChildForm="selectedChildForm"
      ></childtrackingsystem-observationform>
    </div>
    <div
      class="modal fade"
      id="infoModal"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <icon name="look-into"></icon>
              </div>
              <div class="col-9">Bekijk observatielijst</div>
            </div>
            <div class="row">
              <div class="col-3">
                <icon name="reminder"></icon>
              </div>
              <div class="col-9">Herinnering maken voor observatielijst</div>
            </div>
            <div class="row">
              <div class="col-3">
                <icon name="file-contract"></icon>
              </div>
              <div class="col-9">Maak observatieformulier aan</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
import ChildtrackingsystemObservationform from "./ObservationForm";
import icon from "@/components/Icon.vue";

export default {
  name: 'ChildtrackingsystemResults',
  components: { icon, ChildtrackingsystemObservationform, ChildtrackingsystemEditchildobservationlist },
  data() {
    return {
      isLoading: false,
      lists: [],
      selectedList: 0,
      searchedList: 'Alle',
      mentors: [],
      searchedMentor: 'Alle',
      selectedMentor: 0,
      filterChildren: 'all',
      results: [],
      triggerPeriod: false,
      triggerDate: null,
      triggerDescription: null,
      isError: false,
      isSuccess: false,
      isAllResults: true,
      showActive: true,
      isAnalyse: false,
      isChildForm: false,
      selectedResult: 0,
      selectedChildForm: 0
    };
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    },
    filteredRows() {
      return this.$store.getters.globalChildByTextFilter ? this.results.filter(result => result.childName.toLowerCase().includes(this.$store.getters.globalChildByTextFilter.toLowerCase())) : this.results;
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    };
    this.getResults(true);
  },
  methods: {
    getResults(active) {
      this.isLoading = true;
      this.$store.commit("REGISTER_ACTIVE_REQUEST");
      // eslint-disable-next-line no-undef
      if (this.showActive !== active) {
        this.mentors = []
        this.lists = []
      }
      this.showActive = active;
      this.$request.post("/ChildTrackingSystem/results", {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idChild: this.childId,
        idList: this.listId,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        showActive: this.showActive,
        selectedMentor: this.selectedMentor,
        selectedList: this.selectedList,
        selectedFilterChildren: this.filterChildren
      }).then((response) => {
        this.isLoading = false;
        this.$store.commit("REMOVE_ACTIVE_REQUEST");
        if (response.results) {
          this.results = response.results;
          if (this.lists.length < 1) {
            this.lists = response.lists;
          }
          if (this.mentors.length < 1) {
            this.mentors = response.mentors;
          }
        }
      });
    },
    changeTrigger(event) {
      if (event.target.name === 'triggerDate') {
        this.triggerDate = event.target.value;
        this.triggerPeriod = false;
      } else if (event.target.name === 'triggerPeriod') {
        this.triggerPeriod = event.target.value;
        this.triggerDate = null;
      } else {
        this.triggerDescription = event.target.value;
      }
      return event.target.value;
    },
    saveTrigger(idResult) {
      this.$store.commit("REGISTER_ACTIVE_REQUEST");
      // eslint-disable-next-line no-undef
      this.$request.post("/ChildTrackingSystem/triggers", {
        triggerDate: this.triggerDate,
        triggerPeriod: this.triggerPeriod,
        triggerDescription: this.triggerDescription,
        idResult: idResult,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString
      }).then((response) => {
        this.$store.commit("REMOVE_ACTIVE_REQUEST");
        if (response.triggers) {
          this.message = 'Herinnering succesvol opgeslagen';
          this.isSuccess = true;
          this.triggerDate = null;
          this.triggerDescription = null;
          this.triggerPeriod = false;
          setTimeout(() => this.isSuccess = false, 40000)
        } else {
          this.message = 'Er is iets misgegaan bij het opslaan van de herinnering';
          this.isError = true;
          setTimeout(() => this.isError = false, 40000)
        }
      });
    },
    openAnalyse(idResult) {
      this.isAnalyse = true;
      this.selectedResult = idResult;
    },
    openChildForm(idResult, idChildForm) {
      this.isChildForm = true;
      this.selectedResult = idResult;
      this.selectedChildForm = idChildForm;
    },
    searchResults() {
      if (this.searchedMentor === 'Alle') {
        this.selectedMentor = 0;
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id
          }
        })
      }
      if (this.searchedList === 'Alle') {
        this.selectedList = 0;
      } else {
        this.lists.forEach(list => {
          if (list.title.toLowerCase().includes(this.searchedList.toLowerCase())) {
            this.selectedList = list.id
          }
        })
      }
      document.activeElement.blur()
      this.getResults(this.showActive);
    }
  }
};
</script>
<style scoped>

.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}

.button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  background-color: #ffffff;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  height: 40px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: #F87137;
  color: #F87137;
}

.button:hover {
  border-color: #DE4808;
  color: #DE4808;
}

.button:active {
  border-color: #DE4808;
  color: #DE4808;
}

.button:focus {
  border-color: #DE4808;
  color: #DE4808;
  border-width: 2px;
}

.input-date {
  color: #666;
  border: 1px solid #ddd !important;
}

.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>